import FileDnD from "./FileDnD";

export default FileDnD;
